import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { User, Settings, Bell, Keyboard, Link as LinkIcon, ArrowLeft, Moon, Sun, Monitor } from 'lucide-react';
export function AccountPreferencesPage() {
  return <div className="min-h-screen bg-background" data-id="element-5381">
      <header className="h-16 border-b border-border flex items-center px-6 bg-surface" data-id="element-5382">
        <Link to="/app" className="flex items-center gap-2 text-textMuted hover:text-textMain transition-colors text-sm font-medium" data-id="element-5383">
          <ArrowLeft className="w-4 h-4" data-id="element-5384" /> Back to App
        </Link>
      </header>

      <div className="max-w-5xl mx-auto py-10 px-6 flex flex-col md:flex-row gap-10" data-id="element-5385">
        {/* Sidebar */}
        <div className="w-full md:w-64 shrink-0" data-id="element-5386">
          <h1 className="text-2xl font-bold mb-6" data-id="element-5387">Account</h1>
          <nav className="space-y-1" data-id="element-5388">
            <Link to="/account/profile" className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-textMuted hover:bg-surface hover:text-textMain transition-colors text-sm" data-id="element-5389">
              <User className="w-4 h-4" data-id="element-5390" /> Profile
            </Link>
            <Link to="/account/preferences" className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg bg-primary/10 text-primary font-medium text-sm transition-colors" data-id="element-5391">
              <Settings className="w-4 h-4" data-id="element-5392" /> Preferences
            </Link>
            <button className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-textMuted hover:bg-surface hover:text-textMain transition-colors text-sm" data-id="element-5393">
              <Bell className="w-4 h-4" data-id="element-5394" /> Notification Preferences
            </button>
            <button className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-textMuted hover:bg-surface hover:text-textMain transition-colors text-sm" data-id="element-5395">
              <Keyboard className="w-4 h-4" data-id="element-5396" /> Keyboard Shortcuts
            </button>
            <button className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-textMuted hover:bg-surface hover:text-textMain transition-colors text-sm" data-id="element-5397">
              <LinkIcon className="w-4 h-4" data-id="element-5398" /> Linked Accounts
            </button>
          </nav>
        </div>

        {/* Main Content */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="flex-1" data-id="element-5399">
          <div className="bg-surface border border-border rounded-xl p-8" data-id="element-5400">
            <h2 className="text-lg font-semibold mb-6 border-b border-border pb-4" data-id="element-5401">
              App Preferences
            </h2>

            <div className="space-y-8" data-id="element-5402">
              {/* Theme */}
              <div data-id="element-5403">
                <h3 className="text-sm font-medium text-textMain mb-3" data-id="element-5404">
                  Theme
                </h3>
                <div className="grid grid-cols-3 gap-4" data-id="element-5405">
                  <button className="p-4 rounded-xl border-2 border-primary bg-background flex flex-col items-center gap-3 transition-colors" data-id="element-5406">
                    <Moon className="w-6 h-6 text-primary" data-id="element-5407" />
                    <span className="text-sm font-medium text-primary" data-id="element-5408">
                      Dark
                    </span>
                  </button>
                  <button className="p-4 rounded-xl border border-border bg-background flex flex-col items-center gap-3 hover:border-primary/50 transition-colors" data-id="element-5409">
                    <Sun className="w-6 h-6 text-textMuted" data-id="element-5410" />
                    <span className="text-sm font-medium text-textMuted" data-id="element-5411">
                      Light
                    </span>
                  </button>
                  <button className="p-4 rounded-xl border border-border bg-background flex flex-col items-center gap-3 hover:border-primary/50 transition-colors" data-id="element-5412">
                    <Monitor className="w-6 h-6 text-textMuted" data-id="element-5413" />
                    <span className="text-sm font-medium text-textMuted" data-id="element-5414">
                      System
                    </span>
                  </button>
                </div>
              </div>

              <div className="h-px bg-border" data-id="element-5415"></div>

              {/* Form */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-5416">
                <div data-id="element-5417">
                  <label className="block text-sm font-medium text-textMuted mb-1.5" data-id="element-5418">
                    Language
                  </label>
                  <select className="w-full px-4 py-2.5 bg-background border border-border rounded-lg text-sm focus:outline-none focus:border-primary transition-colors appearance-none text-textMain" data-id="element-5419">
                    <option data-id="element-5420">English (US)</option>
                    <option data-id="element-5421">English (UK)</option>
                    <option data-id="element-5422">Spanish</option>
                    <option data-id="element-5423">French</option>
                  </select>
                </div>
                <div data-id="element-5424">
                  <label className="block text-sm font-medium text-textMuted mb-1.5" data-id="element-5425">
                    Date Format
                  </label>
                  <select className="w-full px-4 py-2.5 bg-background border border-border rounded-lg text-sm focus:outline-none focus:border-primary transition-colors appearance-none text-textMain" data-id="element-5426">
                    <option data-id="element-5427">MM/DD/YYYY</option>
                    <option data-id="element-5428">DD/MM/YYYY</option>
                    <option data-id="element-5429">YYYY-MM-DD</option>
                  </select>
                </div>
                <div className="md:col-span-2" data-id="element-5430">
                  <label className="block text-sm font-medium text-textMuted mb-1.5" data-id="element-5431">
                    Default Workspace
                  </label>
                  <p className="text-xs text-textMuted mb-2" data-id="element-5432">
                    This workspace will open automatically when you log in.
                  </p>
                  <select className="w-full px-4 py-2.5 bg-background border border-border rounded-lg text-sm focus:outline-none focus:border-primary transition-colors appearance-none text-textMain" data-id="element-5433">
                    <option data-id="element-5434">The Wildwoods (Artist)</option>
                    <option data-id="element-5435">Sarah & The Sundays (Artist)</option>
                    <option data-id="element-5436">The Empty Bottle (Venue)</option>
                  </select>
                </div>
              </div>

              <div className="pt-6 border-t border-border flex justify-end" data-id="element-5437">
                <button className="px-6 py-2.5 bg-primary text-background rounded-lg font-medium hover:bg-primaryHover transition-colors text-sm shadow-[0_0_15px_rgba(245,158,11,0.2)]" data-id="element-5438">
                  Save preferences
                </button>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </div>;
}